import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';

import { AppBar, Toolbar, TextField, Typography, Button } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'

import AGTheme, { ThemeColors } from '../Theme'
import { RestComponent, Email } from 'react-frontend-utils'
import { logo } from '../App'


export class LoginHelp extends RestComponent {
  
    styles = {
        appTitle: {
           marginLeft: 10,
           textShadow: "2px 2px #333333",
           fontWeight: "bold",
           fontSize: "200%",
           flexGrow: 1   //fill all space to push other elements to the right edge
        }
    }

    _email;
    _hmac;
    _timestamp;

    constructor(props) {
        super(props);
    
        this._email = props.email ? decodeURIComponent(props.email) : null;  //Arrives with the query string set to the desired email
        this._hmac = props.hmac ? decodeURIComponent(props.hmac) : null;    //Arrives with an hmac
        this._timestamp = props.ts ? decodeURIComponent(props.ts) : null;  //Arrives with a timestamp in seconds
       
        this.state.email = "";

        this.state.didRequestTempPassword = false;  //Flag to indicate if the user has submitted a password reset request
    }
    
    _sendPasswordResetEmail = () => {
        if (!Email.validateEmail(this.state.email)) {
            this.showConfirmAlert("Error", "Please enter a valid email address.", 'red');
            return;
        }

        const query = "?email=" + encodeURIComponent(this.state.email);

        this.secureJSONFetch("/forgotpassword/request", {method: "POST"}, this._submitComplete(), this._fetchErrorCallback, query); 
    }


    _submitComplete = () => {
        this.showConfirmAlert("Password Reset", "Please check your email and follow the instructions to reset your password", 'green');
        this.setState({email: ""});
    }

    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }

    _requestTemporaryPassword = () => {

        const query = "?email=" + encodeURIComponent(this._email) + "&hmac=" + encodeURIComponent(this._hmac) + "&ts=" + encodeURIComponent(this._timestamp);

        this.secureJSONFetch("/forgotpassword/verify", {method: "POST"}, this._verifyComplete, this._fetchErrorCallback, query); 
    }

    _verifyComplete = () => {
        this.setState({didRequestTempPassword: true});
        this.showConfirmAlert("Temporary Password Sent", "Please check your email for your temporary password.", 'green', "OK", null, null, 'black', null, this._done);        
    }

    _done = () => {
        window.location.href = "https://membership.accessgrantedsystems.net/";
    }

    render() {

        const serverErrorMessage = this.state.serverError ? <Typography variant="h5">Server Error: {this.state.serverError}</Typography> : null;
      
        const gutterMargin = this.state.isMobile ? 8 : 20;

        return (
            <ThemeProvider theme={AGTheme}>
                <Fragment>

                    {this.getConfirmAlertComponent()  /*inject an alert component*/}  
                    
                    <AppBar position="static" style={{marginBottom: 12, backgroundColor: ThemeColors.appBarBackground}}>
                        <div style={{paddingTop: 0, paddingBottom: 4, paddingLeft: gutterMargin, paddingRight: gutterMargin}}>

                            <Toolbar disableGutters={true}>
                                {logo}
                                <Typography variant="h5" style={this.styles.appTitle}>Login Help</Typography>
                            </Toolbar>
                        </div>
                    </AppBar>
                    
                    {serverErrorMessage}

                    {this._email && this._hmac ? 
                        <Fragment>
                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    You clicked the password reset link in your email.
                                </Typography> 
                            </div>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20, marginTop: 20}}>
                                <Button disabled={this.state.didRequestTempPassword} variant="contained" color="primary" size="small" onClick={() => this._requestTemporaryPassword()}>Click here to receive a Temporary Password</Button>
                            </div>
                        </Fragment> 

                        :

                        <Fragment>
                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    Forgot your password? Reset it by entering your email address below.
                                </Typography> 
                            </div>
                        
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20, marginTop: 20}}>
                                <TextField variant="outlined" size="small" InputLabelProps={{ shrink: true}} label="Email" value={this.state.email} onChange={(e) => this.setState({email: e.target.value})} fullWidth style={{maxWidth: 400}} />
                                <Button variant="contained" color="primary" size="small" onClick={() => this._sendPasswordResetEmail()}>Submit</Button>
                            </div>

                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    Forgot your login email?
                                </Typography> 
                                <Typography variant='body2' style={{marginBottom: 20}}>
                                    Please contact your community administrator or account representative for assistance.
                                </Typography>
                            </div>

                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    I submitted my email above but did not receive anything.
                                </Typography> 
                                <Typography variant='body2' style={{marginBottom: 20}}>
                                    Check your spam folder. If you are still having trouble, <a href="https://accessgrantedsystems.com/contactus/" target="_blank" rel="noopener noreferrer">click here to contact us</a> for assistance.
                                </Typography>
                            </div>

                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    I am still having trouble logging in.
                                </Typography> 
                                <Typography variant='body2' style={{marginBottom: 20}}>
                                    Please contact your community administrator for assistance. If you do not know who that is, <a href="https://accessgrantedsystems.com/contactus/" target="_blank" rel="noopener noreferrer">click here to contact us</a> for assistance.
                                </Typography>
                            </div>

                            <div style={{textAlign: 'center', marginTop: 40}}>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: 10}}>
                                    I am the community administrator and I am having trouble logging in.
                                </Typography> 
                                <Typography variant='body2' style={{marginBottom: 20}}>
                                    <a href="https://accessgrantedsystems.com/contactus/" target="_blank" rel="noopener noreferrer">Click here to contact us</a> for assistance.
                                </Typography>
                            </div>
                        </Fragment>
                    }
                
                </Fragment>
            </ThemeProvider>    
        );
    }
  
}

export default withCookies(withRouter(LoginHelp));



